import { Backdrop, CircularProgress, Grid, Paper, Typography, Avatar, Button, Pagination } from '@mui/material';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import MaterialNotifyComponent from './MaterialNotifyComponent';
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import { lotteryHoverEffect } from '../utils/index';
import AddTaskIcon from '@mui/icons-material/AddTask';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { ConvertToPersianDate } from '../utils/persianDateTools';
import { withRouter } from 'react-router-dom';

function MerchantLotteriesList(props) {
    const { history } = props
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [lotteryData, setLotteryData] = useState(null);
    const [page, setPage] = useState(1);

    const LotteryContainer = styled.div`
        max-height:max-content;
        min-height:220px;
        background-color:#db5726;
        border-radius:1.2rem;
        width:100%;
        margin:auto;
        text-align:center;
        margin:10px 0;
        padding:0.8rem 0;
        transition:0.4s ease-in-out;
        &:hover{
            box-shadow:${lotteryHoverEffect}
        }
    `;
    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };
    const lotteryImage = {
        width: '90%',
        margin: 'auto'
    };
    const DateItem = styled.div`
        display: inline-block;
        width: 33.33%;
        @media screen and (min-width: 320px) and (max-width: 1080px){
            width: 100%;
            margin: 0;
            display: block;
        }
    `;

    useEffect(() => {
        setOpen(true);
        axios.get('api/v1/MerchantLottery/GetMerchantLotteries', {
            params: {
                merchantId: getAuthenticationToken().merchantId,
                take: 100,
                skip: 0
            }
        }).then((response) => {
            setLotteryData(response.data);
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }, []);

    const handleChange = (a, e) => {
        setPage(e);
    }
    const count = (lotteryData ? lotteryData.length : 1);
    const item = lotteryData && lotteryData[page - 1];
    const formButtonElementStyle = {
        margin: "10px 0",
        backgroundColor: '#014171',
        fontSize:'x-large',
        boxShadow: '0px 10px 20px 5px rgba(255, 255, 255, 0.2)'
    };

    const lotteries = item &&
        <Grid item xs={12} sm={12} md={12} xl={12}>
            <LotteryContainer>
                <Typography variant="h5" gutterBottom sx={{ color: '#fff' }}>
                    {item.name}
                </Typography>
                <img style={lotteryImage} src={item.imageURL} alt={item.name} />
                <Typography variant="h6" gutterBottom sx={{ color: '#fff' }}>
                    {item.description}
                </Typography>
                <div style={{ color: '#ddd', marginBottom: '5px' }}>
                    <DateItem><b>تاریخ شروع: </b><span>{ConvertToPersianDate(item.startDate)}</span></DateItem>
                    <DateItem><b>تاریخ پایان: </b><span>{ConvertToPersianDate(item.endDate)}</span></DateItem>
                    <DateItem><b>تاریخ شروع بررسی: </b><span>{ConvertToPersianDate(item.checkConditionFromDate)}</span></DateItem>
                </div>
                <Button style={{ direction: 'ltr' }} onClick={() => { history.push(`/merchantlotterydetail/${item.lotteryId}`) }} color="secondary" variant="contained" endIcon={<AssignmentIcon />} fullWidth> نمایش جزئیات قرعه کشی </Button>
            </LotteryContainer>
        </Grid>;

    return (
        <>
            <Typography variant="h4" gutterBottom>
                {lotteries == null ? "" : "قرعه کشی های باشگاه مشتریان NEC"}
            </Typography>
            <div style={{ textAlign: 'center' }}>
                {lotteries == null ? <h2 style={{ marginTop: '70px', color: '#ffffff' }}>* قرعه کشی فعالی وجود ندارد</h2> : lotteries}
            </div>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <div style={{ display: 'flex', justifyContent: 'space-evenly', position: 'fixed', left: '0', bottom: '0', width: '100%', zIndex: '1' }}>
                    <div style={{ display: 'inline-block',width: '80%' }}>
                        <Button
                            onClick={() => { props.history.push('/') }}
                            id="cancel"
                            name="cancel"
                            variant="contained"
                            color="success"
                            fullWidth
                            style={formButtonElementStyle}>بازگشت</Button>
                    </div>
                </div>
        </>
    );
}

export default withRouter(MerchantLotteriesList);